import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { createUpdateOrder, getAdminLocation, getAllCompanyNameQuery, getCateringField, getCateringProduct, getDepartment, getMeetingByRoom, getMeetingRoomByLocation, searchADColleague } from "../../../services/ApiServices"
import { emailRegex, handleError, maxCateringProductQty, maxExternalAttendees, maxInternalAttendees, minCateringProductQty, minExternalAttendees, minInternalAttendees } from "../../../const"
import { changeAllLocationValue } from "../../../store/slices/APIResponseSlice"
import { getDynamicLabel } from "../../../utils/helpers"
import { useDispatch, useSelector } from "react-redux"
import { InputMask } from "@react-input/mask"
import { Tooltip } from "react-tooltip"
import { toast } from "react-hot-toast"
import CreatableSelect from "react-select/creatable"
import ReactDatePicker from "react-datepicker"
import SunEditor from "suneditor-react"
import ReactSelect from "react-select"
import moment from "moment/moment"
import Select from "react-select"
import "react-tooltip/dist/react-tooltip.css"
import "./WithMeeting.scss"

import Loader from "../../Loader/Loader"

// ==== Imported Image ====
import iconArrow from "../../../assets/img/icon-arrow-down.svg"
import iconDelete from "../../../assets/img/icon-trash.svg"
import iconAdd from "../../../assets/img/icon-add.svg"

export default function WithMeeting() {
    const allCanteenUser = useSelector((state) => state?.APIResponse?.AllCanteenUsers)
    const allLocations = useSelector((state) => state?.APIResponse?.AllLocations)
    const CreateOrderTranslation = useSelector((state) => state.Translation.CreateOrderTranslation)

    const [isLoading, setIsLoading] = useState(false)
    const [isSaveOrderLoading, setIsSaveOrderLoading] = useState(false)
    const [isUserSearchLoading, setIsUserSearchLoading] = useState(false)
    const [isCateringFieldLoading, setIsCateringFieldLoading] = useState(false)
    // const [orderBySearchStatus, setOrderBySearchStatus] = useState(false)
    const [userSearch, setUserSearch] = useState("")
    const [colleaguesList, setColleaguesList] = useState([])
    const [orderByName, setOrderByName] = useState("")
    const [orderByEmail, setOrderByEmail] = useState("")
    const [allMeetingRoom, setAllMeetingRoom] = useState([])
    const [allMeetingsTime, setAllMeetingsTime] = useState([])
    const [allCateringProduct, setAllCateringProduct] = useState([])
    const [allDepartments, setAllDepartments] = useState([])
    const [allCompanyResponse, setAllCompanyResponse] = useState([])
    const [allCateringFields, setAllCateringFields] = useState([])

    const [orderDetails, setOrderDetails] = useState([])

    const [inputLocation, setInputLocation] = useState({ value: 0, label: getDynamicLabel(CreateOrderTranslation?.lblSelectLocation, "Select Location") })
    const [inputDate, setInputDate] = useState(moment().format("YYYY-MM-DD"))
    const [inputMeetingRoom, setInputMeetingRoom] = useState(0)
    const [inputMeetingTime, setInputMeetingTime] = useState({ value: "", label: getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingRoomTime, "Select Meeting Room Time") })
    const [inputDepartment, setInputDepartment] = useState({})
    const [inputCanteenUser, setInputCanteenUser] = useState([])
    const [inputDeliveryMethod, setInputDeliveryMethod] = useState("Delivery")
    const [inputInternal, setInputInternal] = useState(0)
    const [inputExternal, setInputExternal] = useState(0)
    const [inputSharedComment, setInputSharedComment] = useState("")
    const [inputInternalComment, setInputInternalComment] = useState("")
    const [inputOrderStatus, setInputOrderStatus] = useState(0)
    const [invoiceInternal, setInvoiceInternal] = useState(true)
    const [invoiceExternalDetails, setInvoiceExternalDetails] = useState({
        CompanyName: "",
        Address: "",
        Zip: "",
        CVR: "",
        Att: "",
        Mail: ""
    })
    const [companyQueryString, setCompanyQueryString] = useState("")
    const [inputAmount, setInputAmount] = useState("")
    const [fieldValues, setFieldValues] = useState([])
    const [selectedPath, setSelectedPath] = useState([])

    const [showValidationMessage, setShowValidationMessage] = useState(false)

    const [error, setError] = useState({ Status: false, Indexs: [] })

    const locationRef = useRef()
    const meetingRef = useRef()
    const meetingTimeRef = useRef()
    const costCenterRef = useRef()
    const deliveryRef = useRef()
    const wrapperRef = useRef(null)

    // const orderBySearch = useRef()

    const dispatch = useDispatch()

    // Month Names Translations
    const monthNames = useMemo(() => ([
        getDynamicLabel(CreateOrderTranslation?.lblLongJan, "January"),
        getDynamicLabel(CreateOrderTranslation?.lblLongFeb, "February"),
        getDynamicLabel(CreateOrderTranslation?.lblLongMar, "March"),
        getDynamicLabel(CreateOrderTranslation?.lblLongApr, "April"),
        getDynamicLabel(CreateOrderTranslation?.lblLongMay, "May"),
        getDynamicLabel(CreateOrderTranslation?.lblLongJun, "June"),
        getDynamicLabel(CreateOrderTranslation?.lblLongJul, "July"),
        getDynamicLabel(CreateOrderTranslation?.lblLongAug, "August"),
        getDynamicLabel(CreateOrderTranslation?.lblLongSep, "September"),
        getDynamicLabel(CreateOrderTranslation?.lblLongOct, "October"),
        getDynamicLabel(CreateOrderTranslation?.lblLongNov, "November"),
        getDynamicLabel(CreateOrderTranslation?.lblLongDec, "December"),
    ]), [CreateOrderTranslation])

    // Day Names Translations
    const dayNamesShort = useMemo(() => ([
        getDynamicLabel(CreateOrderTranslation?.lblShortSun, "Sun"),
        getDynamicLabel(CreateOrderTranslation?.lblShortMon, "Mon"),
        getDynamicLabel(CreateOrderTranslation?.lblShortTue, "Tue"),
        getDynamicLabel(CreateOrderTranslation?.lblShortWed, "Wed"),
        getDynamicLabel(CreateOrderTranslation?.lblShortThu, "Thu"),
        getDynamicLabel(CreateOrderTranslation?.lblShortFri, "Fri"),
        getDynamicLabel(CreateOrderTranslation?.lblShortSat, "Sat"),
    ]), [CreateOrderTranslation])

    const locale = useMemo(() => ({
        localize: {
            day: n => dayNamesShort[n],
            month: n => monthNames[n],
        },
        formatLong: {
            date: () => "mm/dd/yyyy",
        }
    }), [dayNamesShort, monthNames])

    // Company Query Search
    useEffect(() => {
        let subscribed = true

        const timeout = setTimeout(() => {

            if (companyQueryString?.trim()) {
                getAllCompanyNameQuery(companyQueryString).then((response) => {
                    if (subscribed) {
                        if (typeof response === "object" && response?.length > 0) {
                            setAllCompanyResponse(response)
                        } else {
                            handleError(response)
                        }
                    }
                }).catch((error) => {
                    if (subscribed) {
                        handleError(error)
                    }
                }).finally(() => {
                    if (subscribed) {
                    }
                })
            }
        }, 1000)

        return () => {
            subscribed = false
            clearTimeout(timeout)
        }
    }, [companyQueryString])

    const selectedMeeting = useMemo(() => {
        if (allMeetingsTime?.length > 0 && inputMeetingTime?.value) {
            return (allMeetingsTime ?? [])?.find((d) => (d?.ExchangeICalUId ?? d?.Id) === inputMeetingTime?.value) ?? {}
        } else {
            return {}
        }
    }, [allMeetingsTime, inputMeetingTime?.value])

    const meetingLocation = useMemo(() => {
        if (allLocations?.length > 0 && inputLocation?.value) {
            return allLocations?.find((d) => d?.Id === inputLocation?.value) ?? {}
        } else {
            return {}
        }
    }, [allLocations, inputLocation?.value])

    // Total Price
    const calPrice = useMemo(() => {
        let price = 0
        let filteredData = orderDetails?.filter((d) => d?.ProductName && d?.NumberOfItems && d?.NumberOfItems && d?.Price)
        if (filteredData?.length > 0) {
            filteredData?.forEach((d) => {
                price += d?.NumberOfItems * d?.Price
            })
        }
        return price
    }, [orderDetails])

    const getNewDiscountAmount = useCallback((order) => {
        const totalPrice = (order?.Price ?? 0) * (order?.NumberOfItems ?? 0)
        const discountPercentage = order?.DiscountPercentage ? parseFloat(order?.DiscountPercentage) : 0
        let discountAmount = ((discountPercentage / 100) * totalPrice).toFixed(2)

        return {
            DiscountAmount: discountAmount,
            FinalPrice: discountAmount ? (totalPrice - discountAmount).toFixed(2) : order?.Price
        }
    }, [])

    const discountOrderDetails = useMemo(() => {
        return orderDetails?.map((order) => {
            let totalPrice = order?.Price * order?.NumberOfItems
            let discountPercentage = order?.DiscountPercentage ? parseFloat(order?.DiscountPercentage) : 0
            let discountAmount = Number((discountPercentage / 100) * totalPrice)
            let finalPrice = totalPrice - discountAmount

            return {
                ...order,
                TotalPrice: totalPrice,
                DiscountAmount: discountAmount,
                FinalPrice: finalPrice
            }
        })
    }, [orderDetails])

    // Calculate sum of DiscountAmount using useMemo
    const totalDiscountAmount = useMemo(() => {
        return (discountOrderDetails.reduce((sum, order) => sum + order?.DiscountAmount, 0)).toFixed(2)
    }, [discountOrderDetails])

    // To Set Discount Amount
    useEffect(() => {
        setInputAmount(totalDiscountAmount)
    }, [totalDiscountAmount])

    // const colleagueOptions = useMemo(() => (
    //     (colleaguesList ?? [])?.map((user) => ({
    //         label: `${user.Name} (${user.Email})`,
    //         value: user,
    //     }))
    // ), [colleaguesList])

    const colleagueOptions = useMemo(() => (
        userSearch?.trim().length >= 3 ?
            [userSearch?.trim().length >= 3 ? {
                label: userSearch, value: userSearch
            } : {}, ...colleaguesList?.map((user) => ({
                label: user?.Name ?? "--",
                value: user?.Email,
            }))] : []
    ), [colleaguesList, userSearch])

    const customLoadingIndicator = (props) => (
        <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    )

    const formatOptionLabel = (option, { context }) => {

        if (context === "menu") {
            return (
                <div className="item-card item-card-hover">
                    <div>
                        <b className="txt-name mb-0">{option?.label ?? "--"}</b>
                    </div>
                    <div>
                        <p className="txt-sm mb-0">{option?.value ?? ""}</p>
                    </div>
                </div>
            )
        }

        return (
            <div className="item-card item-card-hover">
                <div>
                    <b className="txt-name mb-0">{option?.label ?? "--"}</b>
                </div>
            </div>
        )
    }

    const handleWrapperClick = () => {
        if (!showValidationMessage && userSearch?.length < 3) {
            setShowValidationMessage(true)
        }
    }

    const handleInputChange = (inputValue) => {
        setUserSearch(inputValue)
        // setShowValidationMessage(false)
    }

    const addRow = () => {
        setOrderDetails([
            ...orderDetails,
            {
                Id: 0,
                ProductName: "",
                NumberOfItems: "",
                Price: "",
                DiscountPercentage: "",
                DiscountAmount: 0,
                FinalTotalPrice: 0,
                DeliveryHour: inputDeliveryMethod === "Delivery" ? moment(selectedMeeting?.Start).format("HH") : "",
                DeliveryMinute: inputDeliveryMethod === "Delivery" ? moment(selectedMeeting?.Start).format("mm") : ""
            }
        ])
    }

    const setValue = (data) => {
        let arr = []
        if (data && data?.ProductOrders && data?.ProductOrders?.length > 0) {
            arr = [
                ...arr,
                ...data?.ProductOrders?.map((d) => ({
                    Id: d?.Product?.Id,
                    ProductName: d?.Product?.Name,
                    NumberOfItems: d?.NumberOfItems,
                    Price: d?.Product?.Price,
                    DiscountPercentage: d?.DiscountPercentage,
                    DeliveryHour: typeof d?.DeliveryHour === "number" ? moment(d?.DeliveryHour, "HH").format("HH") : moment(selectedMeeting?.Start).format("HH"),
                    DeliveryMinute: typeof d?.DeliveryMinute === "number" ? moment(d?.DeliveryMinute, "mm").format("mm") : moment(selectedMeeting?.Start).format("mm")
                }))
            ]
        }
        if (data && data?.ProductOtherOrders && data?.ProductOtherOrders?.length > 0) {
            arr = [
                ...arr,
                ...data?.ProductOtherOrders?.map((d) => ({
                    Id: d?.Id ?? 0,
                    ProductName: d?.Name,
                    NumberOfItems: d?.NumberOfItems,
                    Price: d?.Price,
                    DiscountPercentage: d?.DiscountPercentage,
                    DeliveryHour: typeof d?.DeliveryHour === "number" ? moment(d?.DeliveryHour, "HH").format("HH") : moment(selectedMeeting?.Start).format("HH"),
                    DeliveryMinute: typeof d?.DeliveryMinute === "number" ? moment(d?.DeliveryMinute, "mm").format("mm") : moment(selectedMeeting?.Start).format("mm")
                }))
            ]
        }
        const cateringOrders = arr?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))
        setOrderDetails(cateringOrders?.map((order) => ({
            ...order,
            DiscountAmount: getNewDiscountAmount(order)?.DiscountAmount,
            FinalPrice: getNewDiscountAmount(order)?.FinalPrice
        })))
        setInputDeliveryMethod(data && data?.DeliveryMethod === "Pickup" ? data?.DeliveryMethod : "Delivery")
        setInputCanteenUser(data && data?.CanteenUsers ? data?.CanteenUsers?.map((d) => d?.Id) : [])
        // setInputDepartment(data && data?.Department?.Id ? (
        //     ({ value: data?.Department?.Id, label: data?.Department?.Name })
        // ) : ({ value: 0, label: "Select Costcenter" }))
        setInputDepartment(data && data?.Department?.Id ? (
            data?.Department
        ) : ({}))
        setInputInternal(data?.NumberOfPeople ?? 0)
        setInputExternal(data?.ExternalAttendeesPeoples ?? 0)
        // setInputSharedComment(data?.Comment ?? "")
        setInputSharedComment(data?.CommentHtml ?? data?.Comment ?? "")
        // setInputInternalComment(data && data?.InternalComment ? data.InternalComment : "")
        setInputInternalComment(data?.InternalCommentHtml ?? data.InternalComment ?? "")
        setOrderByName(data && data?.OrderedByName ? data?.OrderedByName : "")
        setOrderByEmail(data && data?.OrderedByEmail ? data?.OrderedByEmail : "")
        setInputOrderStatus(data && data?.OrderStatus ? data?.OrderStatus?.Id : 0)
        setInvoiceInternal(data && Object.keys(data).length > 0 ? data?.InvoiceInternal ? data?.InvoiceInternal : false : true)
        setInvoiceExternalDetails(data && data?.InvoiceExternalDetails ? data?.InvoiceExternalDetails : {
            CompanyName: "",
            Address: "",
            Zip: "",
            CVR: "",
            Att: "",
            Mail: ""
        })
    }

    const removeRow = (order) => {
        setOrderDetails((prev) => prev?.filter((d) => d !== order))
    }

    const handleProductChange = (Id, i, event) => {
        let arr = [...orderDetails]
        let product = allCateringProduct?.length > 0
            ? allCateringProduct?.find((product) => product?.Id === Id)
            : {}
        if (event?.value && event?.label && event?.value === event?.label) {
            // Other Product Case
            arr[i].ProductName = event?.value
            arr[i].Id = event?.value
            setOrderDetails(arr)
        } else {
            arr[i].ProductName = product?.Name ?? ""
            arr[i].Id = product?.Id ?? 0
            setOrderDetails(arr)
        }
        updateOrderPrice()
        updateOrderDiscountPrice()
    }

    const handleQtyChange = (qty, i) => {
        setOrderDetails((prev) => prev?.map((order, orderIndex) => {
            if (orderIndex === i) {
                const newObj = {
                    ...order,
                    NumberOfItems: qty
                }

                return ({
                    ...newObj,
                    DiscountAmount: getNewDiscountAmount(newObj)?.DiscountAmount,
                    FinalPrice: getNewDiscountAmount(newObj)?.FinalPrice
                })
            } else {
                return order
            }
        }))
    }

    // ===============================================================================================
    const handleDeliveryTimeChange = (time, index) => {
        let arr = [...orderDetails]

        setError((prev) => ({ ...prev, Indexs: prev?.Indexs?.filter((i) => i !== index) }))

        // /^(?:[01]\d|2[0-3]):[0-5]\d$/
        const checkLen0 = () => {
            if (time?.length === 0) {
                arr = arr?.map((p, i) => ({
                    ...p,
                    DeliveryHour: i === index ? "" : p?.DeliveryHour,
                    DeliveryMinute: i === index ? "" : p?.DeliveryMinute
                }))
            }
        }
        const checkLen1 = () => {
            if (time?.length === 1) {
                if ((/^[0-2]$/).test(time)) {
                    // position 1
                    arr = arr?.map((p, i) => ({
                        ...p,
                        DeliveryHour: i === index ? time?.slice(0, 1) : p?.DeliveryHour,
                        DeliveryMinute: i === index ? "" : p?.DeliveryMinute
                    }))
                } else {
                    checkLen0()
                }
            }
        }
        const checkLen2 = () => {
            if (time?.length === 2) {
                if ((/^(?:[01]\d|2[0-3])$/).test(time)) {
                    // position 2
                    arr = arr?.map((p, i) => ({
                        ...p,
                        DeliveryHour: i === index ? time?.slice(0, 2) : p?.DeliveryHour,
                        DeliveryMinute: i === index ? "" : p?.DeliveryMinute
                    }))
                } else {
                    checkLen1()
                }
            }
        }
        const checkLen4 = () => {
            if (time?.length === 4) {
                if ((/^(?:[01]\d|2[0-3]):[0-5]$/).test(time)) {
                    // position 4
                    arr = arr?.map((p, i) => ({
                        ...p,
                        DeliveryHour: i === index ? time?.slice(0, 2) : p?.DeliveryHour,
                        DeliveryMinute: i === index ? time?.slice(3, 4) : p?.DeliveryMinute
                    }))
                } else {
                    checkLen2()
                }
            }
        }
        const checkLen5 = () => {
            if (time?.length === 5) {
                if ((/^(?:[01]\d|2[0-3]):[0-5]\d$/).test(time)) {
                    // position 5
                    arr = arr?.map((p, i) => ({
                        ...p,
                        DeliveryHour: i === index ? time?.slice(0, 2) : p?.DeliveryHour,
                        DeliveryMinute: i === index ? time?.slice(3, 5) : p?.DeliveryMinute
                    }))
                } else {
                    checkLen4()
                }
            }
        }

        checkLen0()
        checkLen1()
        checkLen2()
        checkLen4()
        checkLen5()

        setOrderDetails(arr)
    }

    const handleOnBlur = (time, index) => {
        if (time?.length === 1) {
            handleDeliveryTimeChange("0" + time + ":00", index)
        }
        if (time?.length === 2) {
            handleDeliveryTimeChange(time + ":00", index)
        }
        if (time?.length === 4) {
            handleDeliveryTimeChange(time?.slice(0, 2) + ":0" + time?.slice(3, 4), index)
        }
    }
    //===============================================================================================

    const handlePriceChange = (price, i) => {
        setOrderDetails((prev) => prev?.map((order, orderIndex) => {
            if (orderIndex === i) {
                const newObj = {
                    ...order,
                    Price: price,
                }

                return ({
                    ...newObj,
                    DiscountAmount: getNewDiscountAmount(newObj)?.DiscountAmount,
                    FinalPrice: getNewDiscountAmount(newObj)?.FinalPrice
                })
            } else {
                return order
            }
        }))
    }

    const handleProductDiscountChange = (discount, i) => {
        setOrderDetails((prev) => prev?.map((order, orderIndex) => {
            if (orderIndex === i) {
                const newObj = {
                    ...order,
                    DiscountPercentage: discount,
                }

                return ({
                    ...newObj,
                    DiscountAmount: getNewDiscountAmount(newObj)?.DiscountAmount,
                    FinalPrice: getNewDiscountAmount(newObj)?.FinalPrice
                })
            } else {
                return order
            }
        }))
    }

    const handleFieldChange = (fieldId, newValue) => {
        setFieldValues((prevValues) =>
            (prevValues ?? [])?.map((item) =>
                item?.FieldId === fieldId ? { ...item, Value: newValue } : item
            )
        )
    }

    const updateOrderPrice = () => {
        setOrderDetails((prev) => prev?.map((order, orderIndex) => ({
            ...order,
            Price: !order?.ProductName
                ? ""
                : allCateringProduct?.filter((data) => data?.Name?.trim() === order?.ProductName?.trim())?.length
                    ? allCateringProduct?.find((data) => data?.Name?.trim() === order?.ProductName?.trim())?.Price
                    : order?.Price
        })))
    }

    const updateOrderDiscountPrice = () => {
        setOrderDetails((prev) => prev?.map((d) => ({
            ...d,
            Price: !d?.ProductName ? (
                ""
            ) : allCateringProduct?.filter((data) => data?.Name?.trim() === d?.ProductName?.trim())?.length ? (
                allCateringProduct?.find((data) => data?.Name?.trim() === d?.ProductName?.trim())?.Price
            ) : (
                d?.Price
            )
        })))
    }

    const GetDepartments = async () => {
        setIsLoading(true)
        await getDepartment().then((response) => {
            if (response && typeof response === "object" && response?.length > 0) {
                setAllDepartments(response?.filter((department) => department?.Active))
                const defaultDepartment = response?.filter((department) => department?.Active)?.find((department) => department?.IsDefault)
                setInputDepartment({
                    value: 0,
                    label: getDynamicLabel(CreateOrderTranslation?.lblSelectCostCenter, "Select CostCenter")
                })
                // setInputDepartment({
                //     value: defaultDepartment?.Id ?? 0,
                //     label: defaultDepartment?.Name ?? "Select Costcenter"
                // })
            } else {
                setAllDepartments([])
                handleError(response)
            }
        }).catch((error) => {
            setAllDepartments([])
            handleError(error)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const scrollToDiv = () => {
        var prodList = document.getElementById("prodList")
        prodList.scrollIntoView()
    }

    const isRoomAvailable = (roomId, startTime, endTime) => {
        const setMeetRoom = allMeetingRoom?.length > 0
            ? allMeetingRoom?.find((meetingRoom) => roomId === meetingRoom?.Id)
            : []

        const selectedStartTime = moment(startTime).subtract(setMeetRoom?.CateringBuffertime, "m")._d
        const selectedEndTime = moment(endTime).add(setMeetRoom?.CateringBuffertime, "m")._d

        const ownRemovedMeetings = allMeetingsTime?.length > 0 ? (
            allMeetingsTime?.filter((appoint) =>
                !(
                    moment(moment(appoint?.Start)._d).isSame(moment(selectedStartTime).add(setMeetRoom?.CateringBuffertime, "m")._d) &&
                    moment(moment(appoint?.End)._d).isSame(moment(selectedEndTime).subtract(setMeetRoom?.CateringBuffertime, "m")._d)
                )
            )
        ) : ([])

        return ownRemovedMeetings?.every((appointment) =>
            !appointment?.IsBufferMeeting ? (
                !moment(moment(appointment.Start)._d).isSame(selectedStartTime) &&
                !moment(moment(appointment.End)._d).isSame(selectedEndTime) &&
                !moment(moment(appointment.Start)._d).isBetween(selectedStartTime, selectedEndTime) &&
                !moment(moment(appointment.End)._d).isBetween(selectedStartTime, selectedEndTime)
            ) : true
        )
    }

    const CreateUpdateOrder = () => {
        const saveCat = async (data) => {
            setIsSaveOrderLoading(true)
            await createUpdateOrder(data).then((response) => {
                if (!response) {
                    toast.success(getDynamicLabel(CreateOrderTranslation?.msgSuccessOrderCreate, "Order created successfully"))

                    setInputLocation(0)
                    setInputDate(moment().format("YYYY-MM-DD"))
                    setInputMeetingRoom(0)
                    setInputMeetingTime({ value: "", label: getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingRoomTime, "Select Meeting Room Time") })
                } else {
                    handleError(response)
                }
            }).catch((error) => {
                handleError(error)
            }).finally(() => {
                setIsSaveOrderLoading(false)
            })
        }

        // const validationForTime = orderDetails?.map((p, i) => {
        //     const time = p?.DeliveryMinute ? p?.DeliveryHour + ":" + p?.DeliveryMinute : p?.DeliveryHour
        //     return {
        //         ...p,
        //         isValid: time ? (
        //             moment(moment(time, "HH:mm")._d).isSame(moment(moment(selectedMeeting?.Start).format("HH:mm"), "HH:mm")._d) ||
        //             moment(moment(time, "HH:mm")._d).isSame(moment(moment(selectedMeeting?.End).format("HH:mm"), "HH:mm")._d) ||
        //             moment(moment(time, "HH:mm")._d).isBetween(moment(moment(selectedMeeting?.Start).format("HH:mm"), "HH:mm")._d, moment(moment(selectedMeeting?.End).format("HH:mm"), "HH:mm")._d)
        //         ) : true
        //     }
        // })

        const validationForTime = orderDetails?.map((p) => {
            const time = p?.DeliveryMinute ? `${p?.DeliveryHour}:${p?.DeliveryMinute}` : p?.DeliveryHour
            const parsedTime = moment(`${moment(selectedMeeting?.Start).format("YYYY-MM-DD")}T${time}:00`)
            const startTime = moment(selectedMeeting?.Start)
            const endTime = moment(selectedMeeting?.End)

            return {
                ...p,
                isValid: time ? parsedTime.isBetween(startTime, endTime, null, "[]") : true,
            };
        });

        let inValidOrders = []
        if (inputDeliveryMethod === "Delivery") {
            inValidOrders = validationForTime?.map((d, i) => ({ ...d, Index: i }))?.filter((order) => !order?.isValid)
        } else {
            inValidOrders = []
        }

        if (inValidOrders?.length === 0) {
            const data = {
                "Catering": {
                    "DepartmentId": inputDepartment?.Id,
                    "InvoiceInternal": invoiceInternal,
                    "InvoiceExternalDetails": invoiceInternal === false ? invoiceExternalDetails : null,
                    "Responsible": inputCanteenUser?.length > 0 ? inputCanteenUser : [],
                    "NumberOfPeople": inputInternal,
                    "ExternalAttendeesPeoples": inputExternal,
                    "Products": orderDetails?.length > 0
                        ? orderDetails?.filter((d) => allCateringProduct?.filter((data) => data?.Name === d?.ProductName)?.length > 0 && d?.NumberOfItems && d?.NumberOfItems > 0)?.map((d) => ({
                            ProductId: allCateringProduct?.find((data) => data?.Name === d?.ProductName)?.Id,
                            NumberOfItems: d?.NumberOfItems,
                            DiscountPercentage: d?.DiscountPercentage,
                            DeliveryHour: d?.DeliveryHour,
                            DeliveryMinute: d?.DeliveryMinute
                            //  DeliveryHour: inputDeliveryMethod === "Pickup" ? "" : d?.DeliveryHour,
                            // DeliveryMinute: inputDeliveryMethod === "Pickup" ? "" : d?.DeliveryMinute
                        }))
                        : [],
                    "ProductsOther": orderDetails?.length > 0
                        ? orderDetails?.filter((d) => d?.ProductName?.trim() && !allCateringProduct?.some((data) => data?.Name === d?.ProductName) && d?.NumberOfItems)?.map((d) => ({
                            Id: 0,
                            Name: d?.ProductName,
                            NumberOfItems: d?.NumberOfItems,
                            Price: d?.Price,
                            DiscountPercentage: d?.DiscountPercentage,
                            DeliveryHour: d?.DeliveryHour,
                            DeliveryMinute: d?.DeliveryMinute
                            // DeliveryHour: inputDeliveryMethod === "Pickup" ? "" : d?.DeliveryHour,
                            // DeliveryMinute: inputDeliveryMethod === "Pickup" ? "" : d?.DeliveryMinute
                        }))
                        : [],
                    "Comment": (() => {
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = inputSharedComment || "";
                        return tempDiv.textContent || tempDiv.innerText || "";
                    })(),
                    "CommentHtml": inputSharedComment,
                    "InternalComment": (() => {
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = inputInternalComment || "";
                        return tempDiv.textContent || tempDiv.innerText || "";
                    })(),
                    "InternalCommentHtml": inputInternalComment,
                    "DeliveryMethod": inputDeliveryMethod,
                    "OrderStatusId": inputOrderStatus,
                    "OrderedByName": orderByName,
                    "OrderedByEmail": orderByEmail,
                    "FieldValues": fieldValues?.map((field) => ({
                        "FieldId": field?.FieldId ?? 0,
                        "Value": field?.Value ?? ""
                    }))
                },
                "MyDeskMeetingId": selectedMeeting?.Id,
                "MeetingroomId": inputMeetingRoom,
                "ExchangeMeetingId": selectedMeeting?.ExchangeId,
                "ExchangeICalUId": selectedMeeting?.ExchangeICalUId,
            }

            if (
                (invoiceInternal
                    ? (inputDepartment?.Id && !inputDepartment?.ChildDepartments?.length)
                    : (
                        data?.Catering?.InvoiceExternalDetails?.CompanyName?.trim() ?
                            ((
                                data?.Catering?.InvoiceExternalDetails?.CVR ?
                                    (data?.Catering?.InvoiceExternalDetails?.CVR?.length === 13 || data?.Catering?.InvoiceExternalDetails?.CVR?.length === 8) :
                                    true
                            )
                                &&
                                (data?.Catering?.InvoiceExternalDetails?.Mail ?
                                    emailRegex.test(data?.Catering?.InvoiceExternalDetails?.Mail) :
                                    true))
                            : false
                    )
                ) &&
                data?.Catering?.NumberOfPeople + data?.Catering?.ExternalAttendeesPeoples > 0 &&
                data?.Catering?.OrderedByEmail && data?.Catering?.OrderedByName
                && (orderDetails.length > 0 && orderDetails[0]?.NumberOfItems >= 1 && orderDetails[0]?.ProductName !== "")
            ) {
                if (inputDeliveryMethod === "Delivery" && orderDetails.length >= 1 && allMeetingRoom?.find((room) => room?.Id === inputMeetingRoom)?.CateringBuffertime !== 0) {
                    if (isRoomAvailable(inputMeetingRoom, selectedMeeting?.Start, selectedMeeting?.End)) {
                        saveCat(data)
                    } else {
                        // toast.error(`Not getting ${allMeetingRoom?.find((room) => room?.Id === inputMeetingRoom)?.CateringBuffertime} minutes of buffer time!`)
                        toast.error(getDynamicLabel(CreateOrderTranslation?.lblNotGettingBufferTime, "Not getting {Dynamic} minutes of buffer time").replace("{Dynamic}", allMeetingRoom?.find((room) => room?.Id === inputMeetingRoom)?.CateringBuffertime))
                    }
                } else {
                    saveCat(data)
                }
            } else {
                if (!orderDetails[0]?.NumberOfItems >= 1 || orderDetails[0]?.ProductName === "")
                // (data?.Catering?.Products?.length <= 0 || !data?.Catering?.Products[0]?.NumberOfItems >= 1) &&
                // (data?.Catering?.ProductsOther?.length <= 0 || !data?.Catering?.ProductsOther[0]?.NumberOfItems >= 1)
                {
                    toast.error(getDynamicLabel(CreateOrderTranslation?.msgWrnMustOneProduct, "Must have one product!"))
                } else if (invoiceInternal && (!inputDepartment?.Id || inputDepartment?.ChildDepartments?.length > 0)) {
                    toast.error(getDynamicLabel(CreateOrderTranslation?.msgWrnCostCenterRequire, "Costcenter is required!"))
                } else if (!invoiceInternal && data?.Catering?.InvoiceExternalDetails?.CVR && data?.Catering?.InvoiceExternalDetails?.CVR?.length !== 8 && data?.Catering?.InvoiceExternalDetails?.CVR?.length !== 13) {
                    toast.error(getDynamicLabel(CreateOrderTranslation?.msgWrnPleaseEnterCVRNumber, "Please Enter CVR/EAN number must be 8/13 digit long !"))
                } else if (!invoiceInternal && data?.Catering?.InvoiceExternalDetails?.Mail ? !emailRegex.test(data?.Catering?.InvoiceExternalDetails?.Mail) : false) {
                    toast.error(getDynamicLabel(CreateOrderTranslation?.msgWrnInvalidMail, "Input valid mail!"))
                } else if (!invoiceInternal && !data?.Catering?.InvoiceExternalDetails?.CompanyName) {
                    toast.error(getDynamicLabel(CreateOrderTranslation?.msgWrnExternalInvoiceCompanyName, "External invoice company name required!"))
                } else if (data?.Catering?.NumberOfPeople + data?.Catering?.ExternalAttendeesPeoples <= 0) {
                    toast.error(getDynamicLabel(CreateOrderTranslation?.msgWrnAttendeeRequire, "Attendees is required!"))
                } else if (!data?.Catering?.OrderedByName && !data?.Catering?.OrderedByEmail) {
                    toast.error(getDynamicLabel(CreateOrderTranslation?.msgWrnOrderRequire, "Order By is required!"))
                }
            }
        } else {
            setError({ Status: true, Indexs: inValidOrders?.map((order) => order?.Index) })
            scrollToDiv()
            toast?.error(`${getDynamicLabel(CreateOrderTranslation?.msgWrnEnterValidTime, "Please enter valid time between")} ${moment(selectedMeeting?.Start).format("HH:mm")} - ${moment(selectedMeeting?.End).format("HH:mm")} !`)
        }
    }

    const GetAdminLocation = async () => {
        await getAdminLocation().then((response) => {
            dispatch(changeAllLocationValue(response))
        }).catch((error) => {
            dispatch(changeAllLocationValue([]))
            handleError(error)
        })
    }

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowValidationMessage(false)
        }
    }

    const handleSelect = (level, selectedOption) => {
        const newPath = [...selectedPath.slice(0, level), selectedOption]
        setSelectedPath(newPath)

        const finalDept = getDepartmentByPath(newPath.map(opt => opt.value))
        setInputDepartment(finalDept)
    }

    const getDepartmentByPath = (pathIds, currentList = allDepartments) => {
        let current = null;
        for (let id of pathIds) {
            current = currentList.find((d) => d.Id === id)

            if (current?.ChildDepartments?.length) {
                currentList = current.ChildDepartments;
            } else {
                break
            }
        }

        return current
    }

    const renderDropdowns = () => {
        const dropdowns = []
        let currentList = allDepartments

        for (let i = 0; ; i++) {
            const selectedOption = selectedPath[i] || null

            const options = currentList.map((dept) => ({
                label: dept.Name,
                value: dept.Id,
            }))

            dropdowns.push(
                <div key={i} style={{ marginBottom: "10px" }}>
                    <Select
                        value={selectedOption}
                        onChange={(option) => handleSelect(i, option)}
                        options={options}
                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectCostCenter, "Select CostCenter")}
                        className="form-select p-0"
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                border: "none",
                                boxShadow: "none",
                                padding: "8px 10px",
                                borderRadius: 8,
                            }),
                        }}
                        components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => null
                        }}
                    />

                    <span className="txt-sm txt-gray px-1">
                        {currentList?.find((d) => d?.Id === selectedOption?.value)?.ManagerName}
                    </span>
                </div>
            )

            const selectedDept = currentList.find((d) => d.Id === selectedOption?.value)

            if (selectedDept?.ChildDepartments?.length > 0) {
                currentList = selectedDept.ChildDepartments
            } else {
                break;
            }
        }

        return dropdowns;
    }

    const findPathToDepartment = (targetId, nodes = allDepartments, path = []) => {
        for (const node of nodes) {
            const newPath = [...path, node]

            if (node.Id === targetId) return newPath

            if (node.ChildDepartments.length > 0) {
                const result = findPathToDepartment(targetId, node.ChildDepartments, newPath);
                if (result) return result;
            }
        }
        return null
    }

    useEffect(() => {
        if (selectedMeeting?.CateringInfo?.Department?.Id) {
            const fullDeptPath = findPathToDepartment(selectedMeeting?.CateringInfo?.Department?.Id)

            if (fullDeptPath) {
                const formattedPath = fullDeptPath.map((dept) => ({
                    label: dept.Name,
                    value: dept.Id,
                }))
                setSelectedPath(formattedPath)

                const finalDept = getDepartmentByPath(formattedPath.map(d => d.Id))
                setInputDepartment(finalDept)
            }
        }
    }, [selectedMeeting?.CateringInfo?.Department?.Id])

    // useEffect(() => {
    //     if (inputLocation?.value && userSearch.length >= 3) {
    //         searchADColleague(inputLocation?.value, userSearch).then((res) => setColleaguesList(res))
    //     } else {
    //         setColleaguesList([])
    //     }
    // }, [inputLocation, userSearch])

    // Search Colleague
    useEffect(() => {
        let subscribed = true

        const timeout = setTimeout(async () => {
            if (inputLocation?.value && userSearch?.length >= 3) {
                setIsUserSearchLoading(true)
                await searchADColleague(inputLocation?.value, userSearch).then((response) => {
                    if (subscribed) {
                        if (typeof response === "object") {
                            setColleaguesList(response)
                        } else {
                            setColleaguesList((prev) => prev?.length > 0 ? [] : prev)
                            handleError(response)
                        }
                    }
                }).catch((error) => {
                    if (subscribed) {
                        setColleaguesList((prev) => prev?.length > 0 ? [] : prev)
                        handleError(error)
                    }
                }).finally(() => {
                    setIsUserSearchLoading(false)
                })
            } else {
                if (subscribed) {
                    setColleaguesList((prev) => prev?.length > 0 ? [] : prev)
                }
            }
        }, 500)

        return () => {
            clearTimeout(timeout)
            subscribed = false
        }
    }, [inputLocation, userSearch])

    useEffect(() => {
        setValue(selectedMeeting?.CateringInfo ? selectedMeeting?.CateringInfo : {})
    }, [selectedMeeting])

    // GET MEETINGS BY ROOM
    useEffect(() => {
        let subscribed = true

        setInputMeetingTime("")
        if (inputMeetingRoom) {
            setIsLoading(true)
            getMeetingByRoom(inputDate, inputMeetingRoom).then((response) => {
                if (subscribed) {
                    // setAllMeetingsTime(
                    //     response && typeof response === "object" && response?.length > 0
                    //         ? response?.filter((meeting) => !meeting?.IsBufferMeeting)
                    //         : []
                    // )
                    const temp = (response && typeof response === "object" && response?.length > 0
                        ? response?.filter((meeting) => !meeting?.IsBufferMeeting)
                        : []).map((data, index) => ({
                            ...data,
                            UID: data?.ExchangeICalUId && data?.ExchangeICalUId !== "" ? data?.ExchangeICalUId : data?.Id
                        }))
                    setAllMeetingsTime(temp)
                }
            }).catch((error) => {
                if (subscribed) {
                    handleError(error)
                }
            }).finally(() => {
                if (subscribed) {
                    setIsLoading(false)
                }
            })
        } else {
            if (subscribed) {
                setAllMeetingsTime([])
            }
        }
    }, [inputMeetingRoom, inputDate])

    // GET CATERING PRODUCTS
    useEffect(() => {
        let subscribed = true

        if (inputMeetingTime?.value) {
            const payloadData = {
                locationId: inputLocation?.value,
                date: inputDate,
                startTimeMeetingHour: inputMeetingTime?.label?.slice(0, 2),
                startTimeMeetingMinute: inputMeetingTime?.label?.slice(3, 5),
                endTimeMeetingHour: inputMeetingTime?.label?.slice(8, 10),
                endTimeMeetingMinute: inputMeetingTime?.label?.slice(11, 13),
            }

            getCateringProduct(payloadData).then((response) => {
                if (subscribed) {
                    let arr = []
                    response?.length > 0 && response?.forEach((d) => {
                        d?.Products?.length > 0 && arr?.push(...d?.Products)
                    })
                    setAllCateringProduct(arr)
                }
            }).catch((error) => {
                if (subscribed) {
                    handleError(error)
                }
            })
        } else {
            if (subscribed) {
                setAllCateringProduct([])
            }
        }

        return () => { subscribed = false }
    }, [inputMeetingTime, inputLocation?.value, inputDate])

    // GET MEETING ROOM BY LOCATION
    useEffect(() => {
        let subscribed = true

        setInputMeetingRoom(0)
        if (inputLocation?.value) {
            setIsLoading(true)
            getMeetingRoomByLocation(inputLocation?.value).then((response) => {
                if (subscribed) {
                    setAllMeetingRoom(typeof response === "object" && response?.length > 0 ? response : [])
                }
            }).catch((error) => {
                if (subscribed) {
                    handleError(error)
                }
            }).finally(() => {
                if (subscribed) {
                    setIsLoading(false)
                }
            })
        } else {
            if (subscribed) {
                setAllMeetingRoom([])
            }
        }

        return () => { subscribed = false }
    }, [inputLocation?.value])

    // GET CATERING FIELD
    useEffect(() => {
        if (inputMeetingTime?.value) {
            setIsCateringFieldLoading(true)
            getCateringField(selectedMeeting?.CateringInfo?.Id).then((response) => {
                if (typeof response === "object" && response?.length > 0) {
                    setAllCateringFields(response)
                    setFieldValues(response?.map(field => ({
                        FieldId: field?.Id,
                        Value: field?.DefaultValue || ""
                    })))
                } else {
                    handleError(response)
                    setAllCateringFields([])
                    setFieldValues([])
                }
            }).catch((error) => {
                handleError(error)
            }).finally(() => {
                setIsCateringFieldLoading(false)
            })
        }
    }, [inputMeetingTime?.value, selectedMeeting?.CateringInfo?.Id])

    useEffect(() => {
        GetDepartments()
        GetAdminLocation()
    }, [])

    useEffect(() => {
        if (invoiceInternal === true) {
            setInvoiceExternalDetails({
                CompanyName: "",
                Address: "",
                Zip: "",
                CVR: "",
                Att: "",
                Mail: ""
            })
        }
    }, [invoiceInternal])

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [])

    return (
        <>
            {(isLoading || isSaveOrderLoading || isCateringFieldLoading) && <Loader />}

            {/* ========================== Input Section ========================== */}
            {/* ========================== Input Section ========================== */}
            <section className="section mb-4">
                {/* Input Location/Date */}
                <div className="row">
                    {/* Input Location */}
                    <div className="col-6">
                        <div className="inputSec-icon mb-3">
                            <Select
                                ref={locationRef} openMenuOnFocus={true}
                                value={[inputLocation]}
                                onChange={(e) => setInputLocation(e)}
                                options={allLocations?.length > 0
                                    ? [{ value: 0, label: getDynamicLabel(CreateOrderTranslation?.lblSelectLocation, "Select Location") }, ...allLocations?.map((d) => ({ value: d?.Id, label: d?.Name }))]
                                    : [{ value: 0, label: getDynamicLabel(CreateOrderTranslation?.lblSelectLocation, "Select Location") }]
                                }
                                className="form-control p-0"
                                placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectLocation, "Select Location")}
                                styles={{
                                    control: (baseStyles) => ({
                                        ...baseStyles,
                                        border: "none",
                                        boxShadow: "none",
                                        padding: "8px 10px",
                                        borderRadius: 8,
                                    }),
                                }}
                                components={{
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: () => null
                                }}
                            />
                            <span onClick={() => locationRef.current?.focus()} className="custom-drop-down-span">
                                <img className="custom-drop-down-image" alt="icon-user" src={iconArrow} />
                            </span>
                        </div>
                    </div>

                    {/* Input Date */}
                    <div className="col-6">
                        <div className="inputSec-icon">
                            {/* <ReactDatePicker
                                locale={locale}
                                selected={moment(inputDate)._d}
                                onChange={(date) => setInputDate(moment(date).format("YYYY-MM-DD"))}
                                className="form-control"
                                dateFormat="dd.MM.yyyy"
                                calendarStartDay={1}
                            /> */}
                            <ReactDatePicker
                                locale={locale}
                                type="selectedDate"
                                className="form-control"
                                placeholder="DD/MM/YYYY"
                                dateFormat="dd.MM.yyyy"
                                calendarStartDay={1}
                                selected={moment(inputDate)._d}
                                onChange={(date) => setInputDate(moment(date).format("YYYY-MM-DD"))}
                            />
                        </div>
                    </div>
                </div>

                {/* Input MeetingRoom/MeetingTime */}
                <div className="row">
                    {/* Input MeetingRoom */}
                    <div className="col-6">
                        <div className="inputSec-icon">
                            <Select
                                ref={meetingRef} openMenuOnFocus={true} isDisabled={!inputLocation?.value}
                                value={inputMeetingRoom && allMeetingRoom?.length > 0 && [{ value: allMeetingRoom?.find((d) => d?.Id === inputMeetingRoom)?.Id, label: allMeetingRoom?.find((d) => d?.Id === inputMeetingRoom)?.Name }]}
                                onChange={(e) => setInputMeetingRoom(Number(e?.value))}
                                options={allMeetingRoom?.length > 0
                                    ? [{ value: 0, label: getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingRoom, "Select Meeting Room") }, ...allMeetingRoom?.map((d) => ({ value: d?.Id, label: d?.Name }))]
                                    : [{ value: 0, label: getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingRoom, "Select Meeting Room") }]
                                }
                                className="form-control p-0"
                                placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingRoom, "Select Meeting Room")}
                                styles={{
                                    control: (baseStyles) => ({
                                        ...baseStyles,
                                        border: "none",
                                        boxShadow: "none",
                                        padding: "8px 10px",
                                        borderRadius: 8,
                                    }),
                                }}
                                components={{
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: () => null
                                }}
                            />
                            <span onClick={() => meetingRef.current?.focus()} className="custom-drop-down-span">
                                <img className="custom-drop-down-image" alt="icon-user" src={iconArrow} />
                            </span>
                        </div>
                    </div>

                    {/* Input MeetingTime */}
                    <div className="col-6">
                        <div className="inputSec-icon">
                            <Select
                                ref={meetingTimeRef}
                                openMenuOnFocus={true}
                                isDisabled={!inputLocation?.value || !inputMeetingRoom}
                                value={[inputMeetingTime]}
                                onChange={(e) => setInputMeetingTime(e)}
                                options={allMeetingsTime?.length > 0 ? (
                                    [{ value: "", label: getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingTime, "Select Meeting Time") },
                                    ...allMeetingsTime?.map((d) => ({
                                        value: d?.UID,
                                        label: `${moment(d?.Start).format("HH:mm")} - ${moment(d?.End).format("HH:mm")}`
                                    }))]
                                ) : (
                                    [{ value: "", label: getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingTime, "Select Meeting Time") }]
                                )}
                                className="form-control p-0"
                                placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectMeetingTime, "Select Meeting Time")}
                                styles={{
                                    control: (baseStyles) => ({
                                        ...baseStyles,
                                        border: "none",
                                        boxShadow: "none",
                                        padding: "8px 10px",
                                        borderRadius: 8,
                                    }),
                                }}
                                components={{
                                    IndicatorSeparator: () => null,
                                    DropdownIndicator: () => null
                                }}
                            />
                            <span onClick={() => meetingTimeRef.current?.focus()} className="custom-drop-down-span">
                                <img className="custom-drop-down-image" alt="icon-user" src={iconArrow} />
                            </span>
                        </div>
                    </div>
                </div>
            </section>

            {/* ========================== Edit Order Section ========================== */}
            {/* ========================== Edit Order Section ========================== */}
            {inputMeetingTime?.value && (
                <>
                    <div className="card card-revert mt-3 cardhide">
                        <div className="row mb-3 mt-2" id="prodList">
                            <div className="col-9">
                                <div className="pagetitle mt-2"><h2>{getDynamicLabel(CreateOrderTranslation?.lblOrders, "Orders")}</h2></div>
                            </div>
                        </div>

                        {/*================= Orders Table =================*/}
                        <div className="table-responsive table-custom edit">
                            <table className="table table-hover valignM">
                                {orderDetails?.length > 0 && (
                                    <thead>
                                        <tr className="text-center">
                                            <th className="position-relative" style={{ borderBottomWidth: "0px" }}></th>
                                            {/* {inputDeliveryMethod === "Delivery" && ( */}
                                            <th className="delivery-time-td" style={{ borderBottomWidth: "0px" }}></th>
                                            {/* )} */}
                                            <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(CreateOrderTranslation?.lblQty, "Qty.")}</th>
                                            <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(CreateOrderTranslation?.lblPrice, "Price")}</th>
                                            <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(CreateOrderTranslation?.lblDiscount, "Discount")} %</th>
                                            <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(CreateOrderTranslation?.lblDiscountAmount, "Discount Amount")}</th>
                                            <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(CreateOrderTranslation?.lblProductLineTotal, "Product Line Total")}</th>
                                        </tr>
                                    </thead>
                                )}

                                <tbody>
                                    {orderDetails && orderDetails?.length > 0 ? (
                                        orderDetails?.map((order, i) =>
                                            <tr key={i}>
                                                {/* Input Product */}
                                                <td className="position-relative">
                                                    <CreatableSelect
                                                        isClearable
                                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectProduct, "Select Product")}
                                                        value={order?.ProductName && [{ value: order?.Id, label: order?.ProductName }]}
                                                        onChange={(e) => e && handleProductChange(Number(e.value), i, e)}
                                                        options={allCateringProduct?.map((d) => ({ value: d?.Id, label: d?.Name }))}
                                                        components={{
                                                            IndicatorSeparator: () => null,
                                                            DropdownIndicator: () => null,
                                                            ClearIndicator: () => null,
                                                        }}
                                                    />
                                                    {order?.ProductName && allCateringProduct?.filter((d) => d?.Name?.trim() === order?.ProductName?.trim())?.length > 0 && (
                                                        <>
                                                            <i
                                                                className="fa fa-selectedMeeting-circle position-absolute tool-tip"
                                                                data-tooltip-place="top" data-tooltip-id="my-tooltip"
                                                                data-tooltip-content={allCateringProduct?.find((d) => d?.Name?.trim() === order?.ProductName?.trim())?.Notes} />
                                                            <Tooltip id="my-tooltip" />
                                                        </>
                                                    )}
                                                </td>

                                                {/* Input Delivery Time */}
                                                <td className="delivery-time-td">
                                                    <InputMask
                                                        mask="HH:mm"
                                                        onBlur={(e) => handleOnBlur(e.target.value, i)}
                                                        replacement={{ H: /\d/, m: /\d/ }}
                                                        value={(() => {
                                                            const time = orderDetails?.find((prod, index) => index === i)
                                                            return time?.DeliveryMinute ? time?.DeliveryHour + ":" + time?.DeliveryMinute : time?.DeliveryHour
                                                        })()}
                                                        onChange={(e) => handleDeliveryTimeChange(e.target.value, i)}
                                                        separate
                                                        className="form-control text-center"
                                                        placeholder="HH:mm"
                                                        style={{ border: error?.Status && error?.Indexs?.some((prod) => prod === i) && "1px solid red" }}
                                                    />
                                                </td>

                                                {/* Input Quantity */}
                                                <td className="qty-td">
                                                    <input
                                                        type="number"
                                                        min={minCateringProductQty}
                                                        max={maxCateringProductQty}
                                                        className="form-control text-center"
                                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblQty, "Qty.")}
                                                        value={order?.NumberOfItems ?? 0}
                                                        onChange={(e) => {
                                                            const value = e.target.value <= minCateringProductQty
                                                                ? minCateringProductQty
                                                                : e.target.value >= maxCateringProductQty
                                                                    ? maxCateringProductQty
                                                                    : Number(e.target.value)
                                                            if (Number.isInteger(value)) {
                                                                handleQtyChange(value, i)
                                                            }
                                                        }}
                                                    />
                                                </td>

                                                {/* Input Price */}
                                                <td className="price-td">
                                                    <input
                                                        type="number"
                                                        value={order?.Price ?? ""}
                                                        onChange={(e) => {
                                                            const value = e.target.value
                                                            if (value === "" || Number(value) >= 0) {
                                                                handlePriceChange(value === "" ? "" : Number(value), i)
                                                            }
                                                        }}
                                                        disabled={allCateringProduct.some((d) => d?.Name.trim() === order?.ProductName.trim())}
                                                        className="form-control text-center"
                                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblPrice, "Price")}
                                                    />
                                                </td>

                                                {/* Discount Percentage */}
                                                <td className="d-flex align-items-center justify-content-center">
                                                    <span className="d-flex align-items-center justify-content-center flex-grow-1">
                                                        <input
                                                            type="number"
                                                            min={0} max={100}
                                                            value={order?.DiscountPercentage ?? ""}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                const regex = /^\d{0,3}(\.\d{0,2})?$/;

                                                                if (value === "" || (regex.test(value) && Number(value) >= 0 && Number(value) <= 100)) {
                                                                    handleProductDiscountChange(value === "" ? "" : Number(value), i);
                                                                }
                                                            }}
                                                            className="form-control text-center"
                                                            placeholder={`${getDynamicLabel(CreateOrderTranslation?.lblDiscount, "Discount")} %`}
                                                            style={{ borderRight: 0 }}
                                                        />
                                                        <span
                                                            className="input-group-text flex-grow-1"
                                                            style={{ backgroundColor: "white", padding: "16px 12px", outline: "none", border: "none" }}
                                                        >
                                                            <i className="fa-solid fa-percent" />
                                                        </span>
                                                    </span>
                                                </td>

                                                {/* Discount Amount */}
                                                <td>
                                                    <input
                                                        type="text"
                                                        disabled={true}
                                                        className="form-control text-center"
                                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblDiscountAmount, "Discount Amount")}
                                                        value={order?.DiscountAmount ? (
                                                            `${order?.DiscountAmount} ${meetingLocation?.Currency ? meetingLocation?.Currency : "DKK"}`
                                                        ) : ""}
                                                    />
                                                </td>

                                                {/* Final Total */}
                                                <td>
                                                    <input
                                                        type="text"
                                                        disabled={true}
                                                        className="form-control text-center"
                                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblProductLineTotal, "Product Line Total")}
                                                        value={order?.FinalPrice ? (
                                                            `${order?.FinalPrice} ${meetingLocation?.Currency ? meetingLocation?.Currency : "DKK"}`
                                                        ) : ""}
                                                    />
                                                </td>

                                                {/* Delete Button */}
                                                <td className="dlt-td">
                                                    <button onClick={() => removeRow(order)} type="button" className="btn btn-secondary btn-icon">
                                                        <img alt="icon-trash" src={iconDelete} />
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan="12">
                                                <span className="txt-gray d-block no-order">
                                                    {getDynamicLabel(CreateOrderTranslation?.lblNoOrders, "No Orders")}
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {/*================= Discount Amount =================*/}
                            {inputAmount > 0 && (
                                <div className="discount d-flex justify-content-end">
                                    <div className="col-10 p-3 d-flex justify-content-end align-items-center">
                                        <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblDiscount, "Discount")}</span>
                                    </div>

                                    <div className="col-2 d-flex justify-content-end align-items-center">
                                        <div className="input-group">
                                            <input
                                                type="number"
                                                value={inputAmount}
                                                disabled={inputAmount > 0}
                                                className="discount-amount form-control form-control-sm text-center"
                                                placeholder={getDynamicLabel(CreateOrderTranslation?.lblAmount, "Amount")}
                                                style={{ borderRight: "none", boxShadow: "none" }}
                                            />
                                            <span className="input-group-text" style={{ backgroundColor: "white", border: "1px solid #e8ecef" }}>
                                                {meetingLocation?.Currency === "" ? "DKK" : meetingLocation?.Currency}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Total Amount  */}
                            <div className="d-flex justify-content-end">
                                <div className="col-8 p-3 d-flex justify-content-end align-items-center">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblTotal, "Total")}</span>
                                </div>

                                <div className="col-2 d-flex justify-content-center align-items-center">
                                    <span className="txt500">
                                        {inputAmount > 0 ? (calPrice - inputAmount).toFixed(2) : calPrice.toFixed(2)}&nbsp;
                                        {meetingLocation?.Currency === "" ? "DKK" : meetingLocation?.Currency}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/*================= Add Button =================*/}
                        <div className="row mb-2 mt-2">
                            <div className="col-9">
                            </div>
                            <div className="col-3 text-end addNewRowItem">
                                <button onClick={() => addRow()} type="button" className="btn btn-secondary btn-icon btn-icon-lg">
                                    <img src={iconAdd} alt="icon-add" />
                                </button>
                            </div>
                        </div>

                        {/*================= Order Details =================*/}
                        <div className="card-content orderDetails">
                            {/*================= Cost Center =================*/}
                            <div className="row costcenter list mt-3">
                                <div className="col-sm-12 col-md-12 col-lg-3 col-xl-xl-3 txt-md mb-2">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblCostcenterExternalCustomer, "Costcenter/External customer")}<span className="required">*</span></span>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-9 col-xl-xl-9 txt-md mb-2">
                                    <div className="d-flex mb-3">
                                        <div className="form-check d-flex align-items-center me-3">
                                            <div className="d-flex align-items-center">
                                                <label className="form-check-label me-2" htmlFor="internal">
                                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblInternal, "Internal")}</span>
                                                </label>
                                                <input
                                                    type="radio"
                                                    checked={invoiceInternal === true}
                                                    onChange={() => setInvoiceInternal(true)}
                                                    id="internal"
                                                    title={getDynamicLabel(CreateOrderTranslation?.lblInternal, "Internal")}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-check d-flex align-items-center">
                                            <div className="d-flex align-items-center">
                                                <label className="form-check-label me-2" htmlFor="external">
                                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblExternal, "External")}</span>
                                                </label>
                                                <input
                                                    type="radio"
                                                    checked={invoiceInternal === false}
                                                    onChange={() => setInvoiceInternal(false)}
                                                    id="external"
                                                    title={getDynamicLabel(CreateOrderTranslation?.lblExternal, "External")}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <>
                                            {invoiceInternal ? (
                                                <div>
                                                    <div className="inputSec-icon">
                                                        {/* <Select
                                                            ref={costCenterRef} openMenuOnFocus={true}
                                                            value={{ value: inputDepartment?.Id, label: inputDepartment?.Name }}
                                                            onChange={(value) => {
                                                                console.log('value', value)
                                                                setInputDepartment((allDepartments ?? [])?.find((d) => d?.Id === value?.value))
                                                            }}
                                                            options={allDepartments?.length > 0 ? (
                                                                [
                                                                    { value: 0, label: getDynamicLabel(CreateOrderTranslation?.lblSelectCostCenter, "Select CostCenter") },
                                                                    ...allDepartments?.filter((d) => d?.Active)?.find((a) => a?.IsDefault)?.length > 0
                                                                        ? allDepartments?.filter((d) => d?.Active)?.find((a) => a?.IsDefault)
                                                                        : allDepartments?.filter((d) => d?.Active)?.map((data) => ({ value: data?.Id, label: data?.Name }))
                                                                ]
                                                            ) : (
                                                                [{ value: 0, label: getDynamicLabel(CreateOrderTranslation?.lblSelectCostCenter, "Select CostCenter") }]
                                                            )}
                                                            className="form-select p-0"
                                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectCostCenter, "Select CostCenter")}
                                                            styles={{
                                                                control: (baseStyles) => ({
                                                                    ...baseStyles,
                                                                    border: "none",
                                                                    boxShadow: "none",
                                                                    padding: "8px 10px",
                                                                    borderRadius: 8,
                                                                }),
                                                            }}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                                DropdownIndicator: () => null
                                                            }}
                                                        /> */}
                                                        <div>
                                                            {renderDropdowns()}
                                                        </div>
                                                        <span onClick={() => costCenterRef.current?.focus()} className="custom-drop-down-span">
                                                            <img className="custom-drop-down-image" alt="icon-user" src={iconArrow} />
                                                        </span>
                                                    </div>
                                                    {/* <span className="txt-sm txt-gray px-1">
                                                        {allDepartments?.find((d) => d?.Id === inputDepartment?.value)?.ManagerName}
                                                    </span> */}
                                                </div>
                                            ) : (
                                                <div className="row">
                                                    <div className="col-6 col-md-6 col-xl-6 col-xl-6 mb-3">
                                                        <CreatableSelect
                                                            isClearable
                                                            className="CreatableSelect"
                                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblSearchCompany, "Search Company")}
                                                            value={invoiceExternalDetails?.CompanyName && [{ value: invoiceExternalDetails?.CompanyName, label: invoiceExternalDetails?.CompanyName }]}
                                                            onChange={(e) => {
                                                                const companyName = e ? e.value : ""
                                                                const filteredCompany = allCompanyResponse.filter((d) => d?.CompanyName === companyName)[0]

                                                                const updatedAddress = filteredCompany ? filteredCompany?.Address : ""
                                                                const updatedZip = filteredCompany ? filteredCompany?.Zip : ""
                                                                const updatedCVR = filteredCompany ? filteredCompany?.CVR : ""
                                                                const updatedAtt = filteredCompany ? filteredCompany?.Att : ""
                                                                const updatedMail = filteredCompany ? filteredCompany?.Mail : ""

                                                                setInvoiceExternalDetails((prev) => ({
                                                                    ...prev,
                                                                    CompanyName: companyName,
                                                                    Address: updatedAddress,
                                                                    Zip: updatedZip,
                                                                    CVR: updatedCVR,
                                                                    Att: updatedAtt,
                                                                    Mail: updatedMail
                                                                }))
                                                            }}
                                                            onInputChange={(event) => setCompanyQueryString(event)}
                                                            options={allCompanyResponse?.map((d) => ({ value: d?.CompanyName, label: d?.CompanyName }))}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                                DropdownIndicator: () => null,
                                                                ClearIndicator: () => null,
                                                            }}
                                                            styles={{
                                                                control: (baseStyles) => ({
                                                                    ...baseStyles,
                                                                    boxShadow: "none",
                                                                    borderRadius: 8,
                                                                    padding: "8px 10px",
                                                                    fontSize: "18px",
                                                                    border: "1px solid #e8ecef",
                                                                    outline: "none"
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-6 col-md-6 col-xl-6 col-xl-6 mb-3">
                                                        <input
                                                            type="text"
                                                            value={invoiceExternalDetails?.Address}
                                                            onChange={(e) => setInvoiceExternalDetails((prev) => ({ ...prev, Address: e.target.value }))}
                                                            className="form-control"
                                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblAddress, "Address")}
                                                        />
                                                    </div>
                                                    <div className="col-4 col-md-2 col-lg-2 col-xl-2 mb-3">
                                                        <input
                                                            type="text"
                                                            value={invoiceExternalDetails?.Zip}
                                                            onChange={(e) => {
                                                                const value = e.target.value
                                                                if (value) {
                                                                    if (!isNaN(Number(value)) && Number(value) >= 0 && value?.length <= 8) {
                                                                        setInvoiceExternalDetails((prev) => ({ ...prev, Zip: value }))
                                                                    }
                                                                } else {
                                                                    setInvoiceExternalDetails((prev) => ({ ...prev, Zip: "" }))
                                                                }
                                                            }}
                                                            className="form-control"
                                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblZip, "Zip")}
                                                        />
                                                    </div>

                                                    <div className="col-4 col-md-2 col-lg-2 col-xl-2 mb-3">
                                                        <input
                                                            type="text"
                                                            value={invoiceExternalDetails?.CVR ?? ""}
                                                            onChange={(e) => {
                                                                const value = e.target.value
                                                                if (value) {
                                                                    if (!isNaN(Number(value)) && Number(value) >= 0 && value?.length <= 13) {
                                                                        setInvoiceExternalDetails((prev) => ({ ...prev, CVR: value }))
                                                                    }
                                                                } else {
                                                                    setInvoiceExternalDetails((prev) => ({ ...prev, CVR: "" }))
                                                                }
                                                            }}
                                                            className={`form-control ${invoiceExternalDetails?.CVR && (invoiceExternalDetails?.CVR?.length !== 8 && invoiceExternalDetails?.CVR?.length !== 13) ? "border-danger" : ""}`}
                                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblCVREANNumber, "CVR/EAN-Number")}
                                                        />
                                                        {invoiceExternalDetails?.CVR && (invoiceExternalDetails?.CVR?.length !== 8 && invoiceExternalDetails?.CVR?.length !== 13) && (
                                                            <span className="text-danger">{getDynamicLabel(CreateOrderTranslation?.lblCVRMustDigit, "CVR or EAN Number must be either 8 or 13 digits")}</span>
                                                        )}
                                                    </div>
                                                    <div className="col-4 col-md-2 col-lg-2 col-xl-2 mb-3">
                                                        <input
                                                            type="text"
                                                            value={invoiceExternalDetails?.Att}
                                                            onChange={(e) => setInvoiceExternalDetails((prev) => ({ ...prev, Att: e.target.value }))}
                                                            className="form-control"
                                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblATT, "ATT")}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-md-6 col-xl-6 col-xl-6 mb-3">
                                                        <input
                                                            type="text"
                                                            value={invoiceExternalDetails?.Mail}
                                                            onChange={(e) => setInvoiceExternalDetails((prev) => ({ ...prev, Mail: e.target.value }))}
                                                            className="form-control"
                                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblMail, "Mail")}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    </div>
                                </div>
                            </div>

                            {/* Catering Fields */}
                            {allCateringFields?.length > 0 && allCateringFields?.map((field, fieldIndex) => (
                                <div key={fieldIndex} className="row list catering-field">
                                    <div className="col-3 d-flex align-items-center txt-md mt-3">
                                        <span className="txt500">
                                            {field?.Title ?? ""}
                                            {field?.Required && <span className="text-danger ms-1">*</span>}
                                        </span>
                                    </div>

                                    {field?.Type?.Title?.toLocaleLowerCase() === "text" ? (
                                        <div className="col-9 d-flex gap-2 txt-md mt-3">
                                            <input
                                                type="text"
                                                value={fieldValues?.find((item) => item?.FieldId === field?.Id)?.Value ?? ""}
                                                onChange={(e) => handleFieldChange(field.Id, e.target.value)}
                                                placeholder={field?.PlaceholderText ?? ""}
                                                required={field?.Required ?? false}
                                                className="rounded-2 form-control card-input m-0"
                                            />

                                            {field?.HelpText && (
                                                <i
                                                    className="bi bi-info-circle app-theme-color d-flex align-items-center"
                                                    style={{ fontSize: "20px", cursor: "pointer" }}
                                                    data-tooltip-id={`helpText-${fieldIndex}`}
                                                    data-tooltip-html={field?.HelpText ?? ""}
                                                    data-tooltip-place="top"
                                                />
                                            )}

                                            <Tooltip id={`helpText-${fieldIndex}`} style={{ zIndex: 1000, maxWidth: "300px" }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="number"
                                            value={fieldValues?.find((item) => item?.FieldId === field?.Id)?.Value ?? 0}
                                            min={0}
                                            onChange={(e) => handleFieldChange(field.Id, Number(e.target.value))}
                                            required={field?.Required ?? false}
                                            className="form-control card-input mb-0"
                                        />
                                    )}
                                </div>
                            ))}

                            {/*================= Delivery =================*/}
                            <div className="row list mt-3">
                                <div className="col-3 txt-md mt-3">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblDelivery, "Delivery")}<span className="required">*</span></span>
                                </div>
                                <div className="col-9 txt-md mb-2">
                                    <div className="inputSec-icon">
                                        <Select
                                            ref={deliveryRef} openMenuOnFocus={true}
                                            value={[{ value: inputDeliveryMethod, label: inputDeliveryMethod }]}
                                            onChange={(e) => setInputDeliveryMethod(e.value)}
                                            options={[
                                                { value: "Delivery", label: getDynamicLabel(CreateOrderTranslation?.lblDelivery, "Delivery") },
                                                { value: "Pickup", label: getDynamicLabel(CreateOrderTranslation?.lblPickup, "Pickup") }
                                            ]}
                                            className="form-select p-0"
                                            placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectDeliveryMethod, "Select Delivery Method")}
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    border: "none",
                                                    boxShadow: "none",
                                                    padding: "8px 10px",
                                                    borderRadius: 8,
                                                }),
                                            }}
                                            components={{
                                                IndicatorSeparator: () => null,
                                                DropdownIndicator: () => null
                                            }}
                                        />
                                        <span onClick={() => deliveryRef.current.focus()} className="custom-drop-down-span">
                                            <img className="custom-drop-down-image" alt="icon-user" src={iconArrow} />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row list mt-3">
                                {/*================= Internal Attendees =================*/}
                                <div className="txt-md mb-2 mt-2 col-3">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblInternal, "Internal")}<span className="required">*</span></span>
                                </div>
                                <div className="txt-md mb-2 col-3">
                                    <input
                                        type="number"
                                        min={minInternalAttendees}
                                        max={maxInternalAttendees}
                                        className="form-control form-control2"
                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblInternal, "Internal")}
                                        value={inputInternal ?? 0}
                                        onChange={(e) => {
                                            setInputInternal(
                                                e.target.value <= minInternalAttendees
                                                    ? minInternalAttendees
                                                    : e.target.value >= maxInternalAttendees
                                                        ? maxInternalAttendees
                                                        : Number(e.target.value)
                                            )
                                        }}
                                    />
                                </div>

                                {/*================= External Attendees =================*/}
                                <div className="txt-md mb-2 mt-2 col-3 text-center">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblExternal, "External")}</span>
                                </div>
                                <div className="txt-md mb-2 col-3">
                                    <input
                                        type="number"
                                        min={minExternalAttendees}
                                        max={maxExternalAttendees}
                                        className="form-control form-control2"
                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblExternal, "External")}
                                        value={inputExternal ?? 0}
                                        onChange={(e) => {
                                            setInputExternal(
                                                e.target.value <= minExternalAttendees
                                                    ? minExternalAttendees
                                                    : e.target.value >= maxExternalAttendees
                                                        ? maxExternalAttendees
                                                        : Number(e.target.value)
                                            )
                                        }}
                                    />
                                </div>

                                {/*================= Shared Comment =================*/}
                                <div className="txt-md mb-2 mt-2">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblSharedComment, "Shared Comment")}</span>
                                    {/* <textarea value={inputSharedComment} onChange={(e) => setInputSharedComment(e.target.value)} className="form-control mt-2" rows={3} placeholder={getDynamicLabel(CreateOrderTranslation?.lblSharedComment, "Shared Comment")} /> */}
                                    <SunEditor
                                        lang="en"
                                        setOptions={{
                                            height: 200,
                                            buttonList: [
                                                ["formatBlock"],
                                                ["bold", "underline", "removeFormat"],
                                                // ["font"],
                                                ["hiliteColor", "fontColor"],
                                                ["list", "align", "outdent", "indent"],
                                                // ["table"],
                                                // ["link", "image", "video"],
                                                // ["fullScreen", "codeView"],
                                                // ["codeView"],
                                            ], // Or Use buttonList.basic, buttonList.complex Or buttonList.formatting Provided by SunEditor.
                                            font: ["Arial", "Arial Black", "Open Sans", "Cosmic Sans Ms", "Courier New", "Helvetica", "Impact", "Tahoma", "Time New Roman", "Verdana"] // Comment This For Default Options.
                                        }}
                                        setContents={inputSharedComment}
                                        onChange={(content) => setInputSharedComment(content)}
                                        setDefaultStyle="font-family: Open Sans"
                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblSharedComment, "Shared Comment")}
                                    />
                                </div>

                                {/*================= Internal Comment =================*/}
                                <div className="txt-md mb-2 mt-2">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblInternalComment, "Internal Comment")}</span>
                                    {/* <textarea value={inputInternalComment} onChange={(e) => setInputInternalComment(e.target.value)} className="form-control mt-2" rows={3} placeholder={getDynamicLabel(CreateOrderTranslation?.lblInternalComment, "Internal Comment")} /> */}
                                    <SunEditor
                                        lang="en"
                                        setOptions={{
                                            height: 200,
                                            buttonList: [
                                                ["formatBlock"],
                                                ["bold", "underline", "removeFormat"],
                                                // ["font"],
                                                ["hiliteColor", "fontColor"],
                                                ["list", "align", "outdent", "indent"],
                                                // ["table"],
                                                // ["link", "image", "video"],
                                                // ["fullScreen", "codeView"],
                                                // ["codeView"],
                                            ], // Or Use buttonList.basic, buttonList.complex Or buttonList.formatting Provided by SunEditor.
                                            font: ["Arial", "Arial Black", "Open Sans", "Cosmic Sans Ms", "Courier New", "Helvetica", "Impact", "Tahoma", "Time New Roman", "Verdana"] // Comment This For Default Options.
                                        }}
                                        setContents={inputInternalComment}
                                        onChange={(content) => setInputInternalComment(content)}
                                        setDefaultStyle="font-family: Open Sans"
                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblInternalComment, "Internal Comment")}
                                    />
                                </div>

                                {/*================= Delivered By =================*/}
                                {/* <div className="txt-md mt-2">
                                    <span className="txt500">Delivery By</span>
                                    <select value={inputCanteenUser} onChange={(e) => setInputCanteenUser(Number(e.target.value))} className="form-select form-control mt-2" placeholder="Select Deliver by">
                                        <option value={0}>Select Deliver by</option>
                                        {allCanteenUser && allCanteenUser?.length > 0 && (
                                            allCanteenUser?.map((d, i) =>
                                                <option key={i} value={d?.Id}>{d?.Name}</option>
                                            )
                                        )}
                                    </select>
                                </div> */}

                                <div className="txt-md mt-2">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblDeliveryBy, "Delivery By")}</span>
                                    <Select
                                        isMulti
                                        value={allCanteenUser
                                            ?.filter((user) => inputCanteenUser.includes(user.Id))
                                            ?.map((user) => ({ value: user.Id, label: user.Name }))}
                                        options={allCanteenUser?.map((d) => ({ value: d?.Id, label: d.Name }))}
                                        className="form-control p-0"
                                        placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectDeliveryBy, "Select Deliver by")}
                                        onChange={(e) => setInputCanteenUser(e.map((d) => Number(d.value)))}
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                boxShadow: "none",
                                                borderRadius: 8,
                                                padding: "8px 10px",
                                                fontSize: "18px",
                                                border: "1px solid #e8ecef",
                                                outline: "none"
                                            }),
                                        }}
                                        components={{
                                            IndicatorSeparator: () => null,
                                            DropdownIndicator: () => null,
                                            ClearIndicator: () => null,
                                        }}
                                    />
                                </div>

                                {/* ================= Order By =================*/}
                                <div className="mt-2">
                                    <span className="txt500">{getDynamicLabel(CreateOrderTranslation?.lblOrderBy, "Order By")}<span className="required">*</span></span>
                                    <div className="w-100 custom-search-group-create hover mt-2">
                                        <div
                                            className="d-block"
                                            ref={wrapperRef}
                                            onClick={handleWrapperClick}
                                        >
                                            <ReactSelect
                                                className="basic-single"
                                                placeholder={getDynamicLabel(CreateOrderTranslation?.lblSelectOrderBy, "Search order by")}
                                                value={orderByName ? { label: orderByName, value: { Name: orderByName } } : null}
                                                onChange={(selectedOption) => {
                                                    if (selectedOption) {
                                                        setOrderByName(selectedOption?.label)
                                                        setOrderByEmail(selectedOption?.value)
                                                        setUserSearch("")
                                                        setShowValidationMessage(false)
                                                        // setColleaguesList([])
                                                        // setOrderBySearchStatus(false)
                                                    } else {
                                                        setOrderByName("")
                                                        setOrderByEmail("")
                                                    }
                                                }}
                                                isLoading={isUserSearchLoading}
                                                onInputChange={handleInputChange}
                                                options={colleagueOptions}
                                                formatOptionLabel={formatOptionLabel}
                                                components={{
                                                    LoadingIndicator: customLoadingIndicator,
                                                    IndicatorSeparator: () => null,
                                                    DropdownIndicator: () => null,
                                                    ClearIndicator: () => null,
                                                }}
                                                styles={{
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        boxShadow: "none",
                                                        borderRadius: 8,
                                                        padding: "8px 10px",
                                                        fontSize: "18px",
                                                        border: "1px solid #e8ecef",
                                                        outline: "none"
                                                    }),
                                                }}
                                            />
                                        </div>

                                        {(showValidationMessage && userSearch?.length < 3) && (
                                            <div className="search-wrapper" >
                                                <div className="item-card">
                                                    <p className="txt-md">{getDynamicLabel(CreateOrderTranslation?.lblPleaseEnter, "Please enter")} {3 - userSearch?.length} {getDynamicLabel(CreateOrderTranslation?.lblOrMoreCharacters, "or more characters")}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12">
                            <button onClick={() => CreateUpdateOrder()} className="btn btn-primary btn-lg btn-full">
                                {getDynamicLabel(CreateOrderTranslation?.lblSave, "Save")}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}
